// @ts-check
import React from 'react';
import './Badge.css';

/**
 * @typedef {'active' | 'inactive' | 'deleted' | 'warning' | 'success'} BadgeVariant
 */

/**
 * Badge — status pill with non-color affordance (icon + label).
 *
 * Replaces the red/green/grey text-only status indicators in LicenseTable.
 * Each variant pairs a tinted bg + icon glyph + label so screen readers and
 * colorblind users can distinguish state without relying on hue alone.
 *
 * @param {Object} props
 * @param {BadgeVariant} props.variant
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
export function Badge({ variant, children, className = '' }) {
  const icon = ICONS[variant];
  const classes = `badge badge--${variant} ${className}`.trim();

  return (
    <span className={classes}>
      <span className="badge__icon" aria-hidden="true">{icon}</span>
      <span className="badge__label">{children}</span>
    </span>
  );
}

const ICONS = {
  active: '●',
  inactive: '○',
  deleted: '✕',
  warning: '!',
  success: '✓',
};
